/* Luxe — theme script. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var settings = window.themeSettings || { moneyFormat: '{{amount}}', cartType: 'page', routes: { cart: '/cart', cartAdd: '/cart/add' } };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || settings.moneyFormat || '{{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelimiters(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        default: return withDelimiters(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- Mobile menu drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    var openBtn = document.querySelector('[data-drawer-open]');
    if (!drawer || !openBtn) return;
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add('drawer-open');
      openBtn.setAttribute('aria-expanded', 'true');
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      drawer.hidden = true;
      document.body.classList.remove('drawer-open');
      openBtn.setAttribute('aria-expanded', 'false');
      if (lastFocus) lastFocus.focus();
    }
    openBtn.addEventListener('click', open);
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (mq) { if (mq.matches && !drawer.hidden) close(); });
  }

  /* ---------- Desktop dropdowns: close on outside click / Esc ---------- */
  function initDropdowns() {
    var dropdowns = document.querySelectorAll('[data-dropdown]');
    if (!dropdowns.length) return;
    document.addEventListener('click', function (e) {
      dropdowns.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      dropdowns.forEach(function (d) { if (d.open) { d.open = false; d.querySelector('summary').focus(); } });
    });
    dropdowns.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) dropdowns.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---------- Quantity +/- ---------- */
  function initQuantity(root) {
    (root || document).querySelectorAll('[data-quantity]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-quantity-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var min = parseInt(input.min, 10);
          if (isNaN(min)) min = 0;
          var next = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-quantity-step'), 10);
          input.value = Math.max(min, next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Product: variant switching ---------- */
  function initProduct(container) {
    var jsonEl = container.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var selects = container.querySelectorAll('[data-option-index]');
    var idInput = container.querySelector('[data-variant-id]');
    var addButton = container.querySelector('[data-add-button]');
    var addLabel = container.querySelector('[data-add-label]');
    var stickyAdd = container.querySelector('[data-sticky-add]');
    var updateUrl = container.hasAttribute('data-update-url');

    function currentOptions() {
      var values = [];
      selects.forEach(function (s) { values[parseInt(s.getAttribute('data-option-index'), 10)] = s.value; });
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) { if (v.options[j] !== values[j]) { match = false; break; } }
        if (match) return v;
      }
      return null;
    }

    function renderPrice(variant) {
      container.querySelectorAll('[data-price]').forEach(function (el) {
        if (!variant) { el.innerHTML = '<span class="price__current">Unavailable</span>'; return; }
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        var html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
        if (onSale) html += '<s class="price__compare"><span class="visually-hidden">Regular price</span>' + formatMoney(variant.compare_at_price) + '</s><span class="badge badge--sale">Save ' + formatMoney(variant.compare_at_price - variant.price).replace(/[.,]00(?=\D*$)/, '') + '</span>';
        if (!variant.available) html += '<span class="badge badge--muted">Sold out</span>';
        el.innerHTML = html;
        el.classList.toggle('price--sale', !!onSale);
      });
    }

    function showMedia(variant) {
      if (!variant || !variant.featured_media) return;
      var slide = container.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (slide) scrollToSlide(container, slide);
    }

    function onChange() {
      var variant = findVariant(currentOptions());
      renderPrice(variant);
      if (addButton) {
        var available = variant && variant.available;
        addButton.disabled = !available;
        if (addLabel) addLabel.textContent = !variant ? 'Unavailable' : (available ? 'Add to cart' : 'Sold out');
        if (stickyAdd) { stickyAdd.disabled = !available; stickyAdd.textContent = !variant ? 'Unavailable' : (available ? 'Add to cart' : 'Sold out'); }
      }
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      showMedia(variant);
      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', onChange); });
    initStickyBar(container, addButton);
  }

  /* ---------- Sticky add to cart (phones) ---------- */
  function initStickyBar(container, addButton) {
    var bar = container.querySelector('[data-sticky-atc]');
    if (!bar || !addButton || !('IntersectionObserver' in window)) return;
    var stickyAdd = bar.querySelector('[data-sticky-add]');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyAdd) stickyAdd.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('has-sticky-atc', show);
      });
    });
    observer.observe(addButton);
  }

  /* ---------- Gallery thumbnails ---------- */
  function scrollToSlide(container, slide) {
    var track = slide.parentElement;
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    var id = slide.getAttribute('data-media-id');
    container.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === id); });
  }
  function initGallery(container) {
    var track = container.querySelector('[data-gallery-track]');
    if (!track) return;
    container.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var slide = track.querySelector('[data-media-id="' + thumb.getAttribute('data-thumb') + '"]');
        if (slide) scrollToSlide(container, slide);
      });
    });
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        var slide = track.children[index];
        if (!slide) return;
        var id = slide.getAttribute('data-media-id');
        container.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === id); });
      }, 80);
    });
  }

  /* ---------- Cart count + add to cart ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('cart-count--empty', count === 0);
      el.setAttribute('aria-label', count + ' items in cart');
    });
  }

  var toastTimer;
  function showToast(message) {
    var toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.querySelector('[data-toast-message]').textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 5000);
  }

  function initToast() {
    var close = document.querySelector('[data-toast-close]');
    if (close) close.addEventListener('click', function () { document.querySelector('[data-toast]').hidden = true; });
  }

  /* Delivery protection: when the ticked [data-protection] box is in the form and protection is not already in the cart, it is added in the same request. */
  function protectionNeeded(form) {
    var box = form.querySelector('[data-protection]');
    if (!box || !box.checked) return Promise.resolve(null);
    var protId = box.getAttribute('data-protection');
    return fetch(settings.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = (cart.items || []).some(function (i) { return String(i.variant_id) === protId; });
        return inCart ? null : protId;
      })
      .catch(function () { return protId; });
  }

  function initProductForms() {
    if (settings.cartType !== 'notification' || !window.fetch) return;
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      if (form.hasAttribute('data-bound')) return;
      form.setAttribute('data-bound', 'true');
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.name !== 'add') return;
        e.preventDefault();
        var button = form.querySelector('[data-add-button]');
        var error = form.querySelector('[data-form-error]');
        if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
        if (error) error.hidden = true;
        var body = new FormData(form);
        var qty = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
        var quantity = parseInt(qty ? qty.value : (body.get('quantity') || 1), 10) || 1;
        var items = [{ id: parseInt(body.get('id'), 10), quantity: quantity }];
        protectionNeeded(form)
          .then(function (protId) {
            if (protId) items.push({ id: parseInt(protId, 10), quantity: 1 });
            var gw = form.querySelector('[data-giftbox-wrap]');
            if (gw) {
              var gt = gw.querySelector('[data-giftbox-toggle]');
              var gq = parseInt((gw.querySelector('[data-giftbox-qty]') || {}).value, 10) || 0;
              if (gt && gt.checked && gq > 0) {
                var gi = { id: parseInt(gw.getAttribute('data-giftbox'), 10), quantity: gq };
                var gn = ((gw.querySelector('[data-giftbox-note]') || {}).value || '').trim();
                if (gn) gi.properties = { 'Gift note': gn };
                items.push(gi);
              }
            }
            return fetch(settings.routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: items }) });
          })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok) throw new Error(result.data.description || result.data.message || 'Could not add to cart.');
            var first = result.data.items && result.data.items[0];
            var title = (first && first.product_title) || result.data.product_title || 'Item';
            showToast(title + ' added to your cart');
            return fetch(settings.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) { if (cart) updateCartCount(cart.item_count); })
          .catch(function (err) {
            if (error) { error.textContent = err.message; error.hidden = false; }
          })
          .then(function () {
            if (!button) return;
            button.removeAttribute('aria-busy');
            var label = button.querySelector('[data-add-label]');
            button.disabled = !!(label && label.textContent !== 'Add to cart');
          });
      });
    });
  }

  /* ---------- Collection sorting ---------- */
  function initSort() {
    document.querySelectorAll('[data-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Customer addresses: country -> province ---------- */
  function initAddressForms() {
    document.querySelectorAll('[data-country-select]').forEach(function (country) {
      var form = country.closest('form');
      var province = form.querySelector('[data-province-select]');
      var wrapper = form.querySelector('[data-province-wrapper]');
      var defaultCountry = country.getAttribute('data-default');
      if (defaultCountry) {
        for (var i = 0; i < country.options.length; i++) {
          if (country.options[i].value === defaultCountry) { country.selectedIndex = i; break; }
        }
      }
      function fill(initial) {
        var opt = country.options[country.selectedIndex];
        var provinces = [];
        try { provinces = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (e) { provinces = []; }
        province.innerHTML = '';
        if (!provinces.length) { wrapper.hidden = true; return; }
        wrapper.hidden = false;
        var selected = initial ? province.getAttribute('data-default') : '';
        provinces.forEach(function (p) {
          var o = document.createElement('option');
          o.value = p[0]; o.textContent = p[1];
          if (p[0] === selected) o.selected = true;
          province.appendChild(o);
        });
      }
      country.addEventListener('change', function () { fill(false); });
      fill(true);
    });
    document.querySelectorAll('form[data-confirm]').forEach(function (form) {
      form.addEventListener('submit', function (e) { if (!window.confirm(form.getAttribute('data-confirm'))) e.preventDefault(); });
    });
  }

  /* ---------- Login: reopen password recovery after submit ---------- */
  function initRecover() {
    if (document.querySelector('[data-recover-open]') && window.location.hash !== '#recover') window.location.hash = 'recover';
  }

  function initAll() {
    initDrawer();
    initDropdowns();
    initQuantity();
    document.querySelectorAll('[data-product]').forEach(function (c) { initProduct(c); initGallery(c); });
    initToast();
    initProductForms();
    initSort();
    initAddressForms();
    initRecover();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* Re-initialise sections when edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    initQuantity(e.target);
    e.target.querySelectorAll('[data-product]').forEach(function (c) { initProduct(c); initGallery(c); });
    initProductForms();
  });
})();
